import e, { forwardRef as c } from "react";
import { ark as r } from "@ark-ui/react";
import { Toast as t } from "@ark-ui/react/toast";
import { ToastContext as E, Toaster as I, createToaster as k } from "@ark-ui/react/toast";
import { toastRecipe as a } from "@huspy/styled-system/recipes";
import { createStyleContext as n } from "../../utils/createStyleContext.mjs";
const { withProvider: m, withContext: o } = n(a), p = m(t.Root, "root"), T = o(
  t.CloseTrigger,
  "closeTrigger"
), l = o(
  t.Description,
  "description"
), f = o(
  t.Title,
  "title"
), g = c((s, i) => /* @__PURE__ */ e.createElement(r.div, { "data-scope": "toast", "data-part": "toast-icon" }, /* @__PURE__ */ e.createElement(r.svg, { ref: i, ...s }))), d = o(
  g,
  "icon"
), h = {
  Root: p,
  CloseTrigger: T,
  Description: l,
  Title: f,
  Icon: d
};
export {
  h as BaseToast,
  E as ToastContext,
  I as Toaster,
  k as createToaster
};
